import styled from "styled-components";

export const StyledAdvantages = styled("section")(
  ({ theme }) => `
  padding: 80px 48px;
  background: ${theme.colorBgLayout};
`,
);

export const AdvantageCard = styled("div")`
  display: flex;
  gap: 16px;
  align-items: flex-start;
`;

export const IconWrapper = styled("div")(
  ({ theme }) => `
  background: ${theme.colorBgContainer};
  padding: 12px;
  border-radius: ${theme.borderRadiusLG}px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  width: fit-content;
`,
);

export const AdvantageContent = styled("div")`
  flex: 1;
`;

export const AdvantageTitle = styled("h4")(
  ({ theme }) => `
  margin-bottom: 12px;
  color: ${theme.colorText};
  font-size: 18px;
  font-weight: 600;
`,
);

export const AdvantageDescription = styled("p")(
  ({ theme }) => `
  color: ${theme.colorTextSecondary};
  margin: 0;
`,
);

export const VisualizationMockup = styled("div")(
  ({ theme }) => `
  background: linear-gradient(135deg, #e0c3fc 0%, #8ec5fc 100%);
  border-radius: ${theme.borderRadiusLG * 3}px;
  aspect-ratio: 4/3;
  max-height: 450px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(108, 92, 231, 0.15);
`,
);

export const MockupCard = styled("div")(
  ({ theme }) => `
  position: absolute;
  inset: 32px;
  background: ${theme.colorBgContainer};
  border-radius: ${theme.borderRadiusLG * 2}px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`,
);

export const MockupHeader = styled("div")(
  ({ theme }) => `
  height: 16px;
  width: 66%;
  background: ${theme.colorBgTextHover};
  border-radius: ${theme.borderRadius}px;
`,
);

export const MockupInput = styled("div")(
  ({ theme }) => `
  height: 40px;
  background: ${theme.colorBgLayout};
  border-radius: ${theme.borderRadius}px;
`,
);

export const TimeSlotGrid = styled("div")`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
`;

export const TimeSlot = styled("div")<{ $active?: boolean }>(
  ({ theme, $active }) => `
  height: 48px;
  background: ${$active ? "#E0D4FF" : theme.colorBgLayout};
  border: 2px solid ${$active ? theme.colorPrimary : "transparent"};
  border-radius: ${theme.borderRadius}px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: ${$active ? theme.colorPrimary : "transparent"};
`,
);

export const MockupButton = styled("div")(
  ({ theme }) => `
  height: 40px;
  background: ${theme.colorPrimary};
  border-radius: ${theme.borderRadius}px;
  margin-top: auto;
`,
);
